import chroma from "chroma-js";

export default {
    custodianIds: {
        bitgo: 2,
        bitgoSubaccount: 3,
        coinbasePrime: 4,
        coinbasePrimeSubaccount: 5,
        bitgoFiatSubaccount: 6,
        bitgoCryptoSubaccount: 7,
        aleo: 8,
        bitgoRetirementEtc: 9,
        bitgoSubgrantee: 10
    },
    environmentOverrides: {
        "AS": {
            "hideBd": true,
            "agentAlias": "Financial Institution",
            "agentPath": "fis",
            "hideRebalancer": true,
            "hideProducts": true,
            "hideOrderHistory": true
        },
        "SB": {
            "hideRebalancer": true,
            "hideProducts": true,
            "hideChart": true,
            "hideRegulatory": true,
        },
        "TOKEN_MGMT": {
            "hideBd": true,
            "riaAlias": "Organization Admin",
            "riaPath": "oas",
            "agentAlias": "Token Plan",
            "agentPath": "tps",
            "clientAlias": "Grantee",
            "clientPath": "grantees",
            "accountAlias": "Organization",
            "hideTrade": true,
            "hideRebalancer": true,
            "hideProducts": true,
            "hideOrderHistory": true,
            "hideChart": true,
            "hideRegulatory": true
        },
        "FDIC": {
            "riaAlias": "CIDF",
            "riaPath": "cidfs",
            "agentAlias": "Financial Institution",
            "agentPath": "fis",
            "clientAlias": "Customer",
            "clientPath": "customers",
            "hideChart": true,
            "hideRegulatory": true
        }
    },
    status: [
        "PENDING",
        "ACTIVE",
        "INACTIVE"
    ],

    tokenGrantStatus: {
        active: "active",
        cancelled: "cancelled",
        reduced: "reduced"
    },
    unlockSchedule: [
        // "Daily",
        "Monthly",
        "Quarterly",
        // "Yearly",
        "Custom"
    ],
    vestingTerm: [
        "12",
        "24",
        "36",
        "48"
    ],
    cliffWithholding: [
        "1 year cliff",
        "no cliff"
    ],
    grantTypes: [
        "Restricted Token Unit",
        "Restricted Token Award",
        "Warrant"
    ],
    agentTypes: [
        "advisor",
        "token plan"
    ],
    accountTypes: [
        "agent",
        "client"
    ],
    purposeOfAccount: [
        "investment fund",
        "personal investment",
        "trading",
        "cross boarder payment",
        "retirement funds",
        "other"
    ],
    sourceOfFunds: [
        "employment income",
        "investment/trading",
        "proceeds from sale of business",
        "inheritance",
        "retirement funds",
        "seed capital/capital raised",
        "other"
    ],
    incorporationTypes: [
        "Corporation",
        "LLC",
        "Partnership",
        "sole proprietorship",
        "other"
    ],
    beneficiaryTypes: [
        "Primary",
        "Contingent"
    ],
    etcAccountTypes: [
        "Traditional IRA",
        "Roth IRA",
        "SEP IRA"
    ],
    etcPaymentMethods: [
        "Deduct from Account",
        "Credit Card"
    ],
    etcFundingMethods: [
        "Contribution",
        // "Conversion",
        // "Deposit",
        // "Recharacterization",
        "Rollover",
        "Transfer"
    ],
    etcStatementPreferences: [
        "Paper",
        "Electronic"
    ],
    usStates: require("./states.json").map(state => state.abbreviation),
    countries: require("./countries.json"),
    bankOwnerTypes: [
        {
            name: "Personal",
            value: "individual account"
        },
        {
            name: "Corporate",
            value: "corporate account"
        }
    ],
    bankAccountTypes: [
        "checking",
        "savings"
    ],
    tradeTypes: [
        "instant",
        "smart_routing",
        "gorilla",
        "tortoise",
        "hare",
        "stop_loss",
        "polar_bear",
        "sniper",
        "twap"
    ],
    feeFrequencies: [
        "monthly",
        "quarterly"
    ],
    accountingMethods: [
        {
            name: "FIFO",
            value: "fifo"
        },
        {
            name: "LIFO",
            value: "lifo"
        },
        {
            name: "High Cost",
            value: "highCost"
        }
    ],
    reportingPartner: [
        {
            name: "Orion",
            value: "orion"
        },
        {
            name: "Electra",
            value: "electra"
        },
        {
            name: "Black Diamond",
            value: "blackDiamond"
        },
        {
            name: "Galaxy Plus",
            value: "galaxyPlus"
        },
        {
            name: "MorningStar",
            value: "morningStar"
        }
    ],
    clientSelectStyles: {
        control: styles => ({...styles, backgroundColor: "white"}),
        option: (styles, {data, isDisabled, isFocused, isSelected}) => {
            const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                        ? data.color
                        : isFocused
                            ? color.alpha(0.1).css()
                            : null,
                color: isDisabled
                    ? "#ccc"
                    : isSelected
                        ? chroma.contrast(color, "white") > 2
                            ? "white"
                            : "black"
                        : data.color,
                cursor: isDisabled ? "not-allowed" : "default",

                ":active": {
                    ...styles[":active"],
                    backgroundColor: !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
                },
            };
        },
        multiValue: (styles, {data}) => {
            const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: color.alpha(0.1).css(),
            };
        },
        multiValueLabel: (styles, {data}) => ({
            ...styles,
            color: data.color,
        }),
        multiValueRemove: (styles, {data}) => ({
            ...styles,
            color: data.color,
            ":hover": {
                backgroundColor: data.color,
                color: "white",
            },
        }),
    }
};
